import { commonFilterSchemaModule } from '@/components/common/filter/filters/CommonFilterSchemaModule';
import { SimpleFilterOptions } from '@/components/common/filter/filters/types';
import { IFormLayout } from '@/uikit/forms/NForm.vue';
import { dataModule } from '@/store/data';
import { dataServiceFactory } from '@/definitions/services/data.services';
import { configModule } from '@/store/config';

const deliveryChannels = [
  { value: 'websocket', i18n_label: 'alerts.deliveryChannels.alarm_screen' },
  { value: 'telegram', i18n_label: 'alerts.deliveryChannels.telegram' }
];

export function getAlertsFiltersBuilder(options: SimpleFilterOptions) {
  const loadTags = async () => {
    const axios = dataServiceFactory.getAxiosInstance();
    const result = await axios.get('/v1/alert-rules/tags/');
    return (result.data?.tags || []).map((v: string) => ({ value: v, label: v }));
  };

  const hasTelegram = configModule.config.services?.alerts?.telegram;

  return [
    commonFilterSchemaModule.getDateRange({ ...options, i18n_label: 'common.creation_date' }),
    commonFilterSchemaModule.getUser({ ...options, path: 'created_by' }),
    commonFilterSchemaModule.getActiveStatus({ ...options }),
    commonFilterSchemaModule.getCameraGroups({ ...options, path: 'camera_group_in', items: dataModule.cameraGroupsWithoutVideoGroups }),
    commonFilterSchemaModule.getCameras({ ...options, path: 'camera_in' }), // , items: mapObjectToSelectItem(dataModule.camerasModule.items)
    commonFilterSchemaModule.getTags({ ...options, path: 'tag_in', loadItems: loadTags }),
    hasTelegram
      ? commonFilterSchemaModule.getAnnexAlarmReaction({
          ...options,
          path: 'delivery_channel',
          i18n_label: 'alerts.delivery_channels',
          i18n_placeholder: 'alerts.delivery_channels',
          items: deliveryChannels
        })
      : null
  ].filter((item) => !!item) as IFormLayout;
}
